import {
  FETCH_ADDRESS_SHIPPER_LOADING,
  FETCH_ADDRESS_SHIPPER_DONE,
  FETCH_ADDRESS_SHIPPER_ERROR,

  FETCH_ADDRESS_CONSIGNEE_LOADING,
  FETCH_ADDRESS_CONSIGNEE_DONE,
  FETCH_ADDRESS_CONSIGNEE_ERROR,

  CREATE_ADDRESS_LOADING,
  CREATE_ADDRESS_DONE,
  CREATE_ADDRESS_ERROR,

  EDIT_ADDRESS_LOADING,
  EDIT_ADDRESS_DONE,
  EDIT_ADDRESS_ERROR,

  POST_DATA_ADDRESS_TEMP,
  POST_DATA_ADDRESS_TEMP_DONE,

  DELETE_ADDRESS_LOADING,
  DELETE_ADDRESS_DONE,
  DELETE_ADDRESS_ERROR,

  FETCH_ALL_ADDRESS_VERIVIED_LOADING,
  FETCH_ALL_ADDRESS_VERIVIED_DONE,
  FETCH_ALL_ADDRESS_VERIVIED_ERROR,

  FETCH_ALL_ADDRESS_VERIVIED_FILTER_LOADING,
  FETCH_ALL_ADDRESS_VERIVIED_FILTER_DONE,
  FETCH_ALL_ADDRESS_VERIVIED_FILTER_ERROR,

  FETCH_ALL_ADDRESS_LOADING,
  FETCH_ALL_ADDRESS_DONE,
  FETCH_ALL_ADDRESS_ERROR,
  
  FETCH_ALL_ADDRESS_FILTER_LOADING,
  FETCH_ALL_ADDRESS_FILTER_DONE,
  FETCH_ALL_ADDRESS_FILTER_ERROR,

  ADD_MORE_ADDRESS_LOADING,
  ADD_MORE_ADDRESS_DONE,
  ADD_MORE_ADDRESS_ERROR,

  REMOVE_ADDRESS_LOADING,
  REMOVE_ADDRESS_DONE,
  REMOVE_ADDRESS_ERROR,
  
  GET_BILLING_ADDRESS_LOADING,
  GET_BILLING_ADDRESS_DONE,
  GET_BILLING_ADDRESS_ERROR,

  BILLING_ADDRESS_GLOBAL,
  BILLING_ADDRESS_GLOBAL_DONE,

  SET_BILLING_ADDRESS_LOADING,
  SET_BILLING_ADDRESS_DONE,
  SET_BILLING_ADDRESS_ERROR,

  EDIT_MY_ADDRESS_LOADING,
  EDIT_MY_ADDRESS_ERROR,
  EDIT_MY_ADDRESS_DONE,

  SHIPPER_SEARCH_ADDRESS_LOADING,
  SHIPPER_SEARCH_ADDRESS_ERROR,
  SHIPPER_SEARCH_ADDRESS_DONE,

  CONSIGNEE_SEARCH_ADDRESS_LOADING,
  CONSIGNEE_SEARCH_ADDRESS_ERROR,
  CONSIGNEE_SEARCH_ADDRESS_DONE
} from './actions'

export default {
  [FETCH_ADDRESS_SHIPPER_LOADING] (state) {
    state.isLoadingShipperList = true
  },
  [FETCH_ADDRESS_SHIPPER_DONE] (state, items) {
    state.shipperList = items
    state.isLoadingShipperList = false
  },
  [FETCH_ADDRESS_SHIPPER_ERROR] (state, error) {
    state.errorShipperList = error
    state.isLoadingShipperList = false
  },

  [FETCH_ADDRESS_CONSIGNEE_LOADING] (state) {
    state.isLoadingConsigneeList = true
  },
  [FETCH_ADDRESS_CONSIGNEE_DONE] (state, items) {
    state.consigneeList = items
    state.isLoadingConsigneeList = false
  },
  [FETCH_ADDRESS_CONSIGNEE_ERROR] (state, error) {
    state.errorConsigneeList = error
    state.isLoadingConsigneeList = false
  },

  [CREATE_ADDRESS_LOADING] (state) {
    state.isCreating = true
    state.isCreated = false
  },
  [CREATE_ADDRESS_DONE] (state, items) {
    state.isCreated = items
    state.isCreating = false
  },
  [CREATE_ADDRESS_ERROR] (state, error) {
    state.errorCreated = error
    state.isCreating = false
    state.isCreated = false
  },

  [EDIT_ADDRESS_LOADING] (state) {
    state.isLoadingEditAddress = true
  },
  [EDIT_ADDRESS_DONE] (state, items) {
    state.editAddress = items
    state.isLoadingEditAddress = false
  },
  [EDIT_ADDRESS_ERROR] (state, error) {
    state.errorEditAddress = error
    state.isLoadingEditAddress = false
  },

  [POST_DATA_ADDRESS_TEMP] (state) {
    state.isLoadingDataAddress = true
  },
  [POST_DATA_ADDRESS_TEMP_DONE] (state, items) {
    state.dataAddressTemp = null
    state.isLoadingDataAddress = false
    state.dataAddressTemp = items
  },

  [DELETE_ADDRESS_LOADING] (state) {
    state.isLoadingDelete = true
  },
  [DELETE_ADDRESS_DONE] (state, items) {
    state.messageDelete = items
    state.isLoadingDelete = false
  },
  [DELETE_ADDRESS_ERROR] (state, error) {
    state.isLoadingDelete = false
    state.errorDelete = error
  },

  [FETCH_ALL_ADDRESS_VERIVIED_LOADING] (state) {
    state.isLoadingAddressVerivied = true
  },
  [FETCH_ALL_ADDRESS_VERIVIED_DONE] (state, items) {
    state.addressVerivied = items
    state.isLoadingAddressVerivied = false
  },
  [FETCH_ALL_ADDRESS_VERIVIED_ERROR] (state, error) {
    state.errorAddressVerivied = error
    state.isLoadingAddressVerivied = false
  },

  [FETCH_ALL_ADDRESS_VERIVIED_FILTER_LOADING] (state) {
    state.isLoadingAddressVeriviedFilter = true
  },
  [FETCH_ALL_ADDRESS_VERIVIED_FILTER_DONE] (state, items) {
    state.addressVeriviedFilter = items
    state.isLoadingAddressVeriviedFilter = false
  },
  [FETCH_ALL_ADDRESS_VERIVIED_FILTER_ERROR] (state, error) {
    state.errorAddressVeriviedFilter = error
    state.isLoadingAddressVeriviedFilter = false
  },

  [FETCH_ALL_ADDRESS_LOADING] (state) {
    state.isLoadingAddress = true
  },
  [FETCH_ALL_ADDRESS_DONE] (state, items) {
    state.address = items
    state.isLoadingAddress = false
  },
  [FETCH_ALL_ADDRESS_ERROR] (state, error) {
    state.errorAddress = error
    state.isLoadingAddress = false
  },

  [FETCH_ALL_ADDRESS_FILTER_LOADING] (state) {
    state.isLoadingAddressFilter = true
  },
  [FETCH_ALL_ADDRESS_FILTER_DONE] (state, items) {
    state.addressFilter = items
    state.isLoadingAddressFilter = false
  },
  [FETCH_ALL_ADDRESS_FILTER_ERROR] (state, error) {
    state.errorAddressFilter = error
    state.isLoadingAddressFilter = false
  },

  [ADD_MORE_ADDRESS_LOADING] (state) {
    state.isLoadingAddMoreAddress = true
  },
  [ADD_MORE_ADDRESS_DONE] (state, items) {
    state.addMoreAddress = items
    state.isLoadingAddMOreAddress = false
  },
  [ADD_MORE_ADDRESS_ERROR] (state, error) {
    state.errorAddMoreAddress = error
    state.isLoadingAddMoreAddress = false
  },

  [REMOVE_ADDRESS_LOADING] (state) {
    state.isLoadingRemoveAddress = true
  },
  [REMOVE_ADDRESS_DONE] (state, items) {
    state.removeAddress = items
    state.isLoadingRemoveAddress = false
  },
  [REMOVE_ADDRESS_ERROR] (state, error) {
    state.errorRemoveAddress = error
    state.isLoadingRemoveAddress = false
  },

  [SET_BILLING_ADDRESS_LOADING] (state) {
    state.isLoadingSetBillingAddress = true
  },
  [SET_BILLING_ADDRESS_DONE] (state, items) {
    state.setBillingAddress = items
    state.isLoadingSetBillingAddress = false
  },
  [SET_BILLING_ADDRESS_ERROR] (state, error) {
    state.errorSetBillingAddress = error
    state.isLoadingSetBillingAddress = false
  },

  [EDIT_MY_ADDRESS_LOADING] (state) {
    state.isLoadingEditMyAddress = true
  },
  [EDIT_MY_ADDRESS_DONE] (state, items) {
    state.editMyAddress = items
    state.isLoadingEditMyAddress = false
  },
  [EDIT_MY_ADDRESS_ERROR] (state, error) {
    state.errorEditMyAddress = error
    state.isLoadingEditMyAddress = false
  },
  [GET_BILLING_ADDRESS_LOADING] (state) {
    state.isLoadingBillingAddress = true
  },
  [GET_BILLING_ADDRESS_DONE] (state, items) {
    state.billingAddress = items
    state.isLoadingBillingAddress = false
  },
  [GET_BILLING_ADDRESS_ERROR] (state, error) {
    state.errorBillingAddress = error
    state.isLoadingBillingAddress = false
  },

  [BILLING_ADDRESS_GLOBAL] (state) {
    state.isLoadingDataBillingGlobal = true
  },
  [BILLING_ADDRESS_GLOBAL_DONE] (state, items) {
    state.billingAddressGlobal = null
    state.isLoadingDataBillingGlobal = false
    state.billingAddressGlobal = items
  },

  [SHIPPER_SEARCH_ADDRESS_LOADING] (state) {
    state.isLoadingShipperList = true
  },
  [SHIPPER_SEARCH_ADDRESS_DONE] (state, items) {
    state.shipperList = items
    state.isLoadingShipperList = false
  },
  [SHIPPER_SEARCH_ADDRESS_ERROR] (state, error) {
    state.errorShipperList = error
    state.isLoadingShipperList = false
  },

  [CONSIGNEE_SEARCH_ADDRESS_LOADING] (state) {
    state.isLoadingConsigneeList = true
  },
  [CONSIGNEE_SEARCH_ADDRESS_DONE] (state, items) {
    state.consigneeList = items
    state.isLoadingConsigneeList = false
  },
  [CONSIGNEE_SEARCH_ADDRESS_ERROR] (state, error) {
    state.errorConsigneeList = error
    state.isLoadingConsigneeList = false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/address/mutations.js